import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import { PrivilegesGroup } from "../../../models/response/user/privileges-group";
import { ApiConfig } from "../../../services/api-config";

const API_VERSION = "v1";
const buildRoot = () => `${API_VERSION}/privilege-groups`;

export interface PrivilegeGroupListResponse {
  list: PrivilegesGroup[];
  total_record?: number;
  limit?: number;
}

export interface PrivilegeGroupListFilters {
  status?: number;
  keyword?: string;
}

const PrivilegeGroupService = {
  list: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<PrivilegeGroupListResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });

    const list = async (
      params: PrivilegeGroupListFilters = { status: 1 }
    ): Promise<BaseResponse<PrivilegeGroupListResponse> | undefined> =>
      request({
        endPoint: buildRoot(),
        data: params,
      });

    return { list, response: baseResponse, loading };
  },
};

export default PrivilegeGroupService;
